export const homeModule = {
  address: "地址",
  currentAddress: "位置信息",
  position: "定位",
  positioning: "正在定位",
  positionFail: "定位失敗",
  addressList: "地址列表",
  reposition: "重新定位",
  recommendStore: "推薦店鋪",
  sort1: "綜合排序",
  sort2: "好評優先",
  sort3: "人均從低到高",
  sort4: "人均從高到低",
  sort5: "配送費最低",
  filterDistance: "距離",
  filterSales: "銷量",
  filter: "篩選",
  filterPrice: "價格篩選",
  devCondition: "配送條件",
  storeType: "店鋪類型",
  manage: "管理",
  positionError: "定位时间过长或定位失败，请手动选择地址",
  changeText: "变更",
  noAddressTitle: "根据地址搜索店铺",
  memberPrivilege: "會員特權",
  productCoupon: "儲值卡",
  appointment: "預約",
  lineUp: "排隊",
};
export const searchModule = {
  sort: "排序",
  addressPlace: "請輸入店鋪名",
  historySearch: "歷史搜索",
  noData: "沒有數據"
};
